import { useState, useEffect } from 'react'
import { BaseModal } from './BaseModal'
import { getLeaderboard, LeaderboardEntry } from '../../lib/api'

type Props = {
  isOpen: boolean
  handleClose: () => void
  currentUsername: string
}

export const LeaderboardModal = ({ isOpen, handleClose, currentUsername }: Props) => {
  const [entries, setEntries] = useState<LeaderboardEntry[]>([])
  const [registeredPlayers, setRegisteredPlayers] = useState<LeaderboardEntry[]>([])
  const [minGames, setMinGames] = useState(10)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setLoading(true)
      getLeaderboard()
        .then((data) => {
          setEntries(data.leaderboard)
          setRegisteredPlayers(data.registeredPlayers)
          setMinGames(data.minGames)
        })
        .catch(() => {
          setEntries([])
          setRegisteredPlayers([])
        })
        .finally(() => setLoading(false))
    }
  }, [isOpen])

  const renderTable = (rows: LeaderboardEntry[], showRank: boolean) => (
    <table className="w-full mt-4 text-sm">
      <thead>
        <tr className="text-gray-500 dark:text-gray-400 border-b dark:border-gray-600">
          <th className="py-2 text-center">#</th>
          <th className="py-2 text-left">群友</th>
          <th className="py-2 text-center">平均猜测</th>
          <th className="py-2 text-center">胜率</th>
          <th className="py-2 text-center">场次</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((entry, i) => {
          const isMe = entry.username === currentUsername
          const rowClass = isMe
            ? 'border-b dark:border-gray-700 text-red-600 dark:text-red-400 font-bold'
            : 'border-b dark:border-gray-700 dark:text-gray-200'
          return (
            <tr key={entry.username} className={rowClass}>
              <td className="py-2 text-center font-medium">
                {showRank ? `${i === 0 ? '🏆 ' : ''}${i + 1}` : '-'}
              </td>
              <td className="py-2 text-left">{entry.username}</td>
              <td className="py-2 text-center">
                {entry.averageGuesses !== null ? entry.averageGuesses : '-'}
              </td>
              <td className="py-2 text-center">
                {entry.winRate !== null ? `${entry.winRate}%` : '-'}
              </td>
              <td className="py-2 text-center">{entry.gamesPlayed}</td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )

  return (
    <BaseModal title="排行榜" isOpen={isOpen} handleClose={handleClose}>
      {loading ? (
        <p className="py-4 text-gray-500">加载中...</p>
      ) : (
        <div>
          {entries.length === 0 ? (
            <p className="py-4 text-gray-500">暂无数据（需要{minGames}场以上才能上榜）</p>
          ) : (
            renderTable(entries, true)
          )}

          <h4 className="mt-6 text-sm font-bold text-gray-700 dark:text-gray-200">
            已注册玩家
          </h4>
          {registeredPlayers.length === 0 ? (
            <p className="py-4 text-gray-500">暂无未上榜玩家</p>
          ) : (
            renderTable(registeredPlayers, false)
          )}
        </div>
      )}
    </BaseModal>
  )
}
